// Feature flags read from Vite env vars. Kept as pure functions rather than a
// hook so they can be called from anywhere (routes, nav, dashboard cards)
// without wiring through React context. Vite substitutes VITE_* at build
// time, so the value is stable for the life of the bundle — no runtime toggle.

function readFlag(raw: string | undefined, defaultValue: boolean): boolean {
  if (raw === undefined) return defaultValue;
  return raw.toLowerCase() === 'true';
}

// PLAN 5-20: the standalone recording/syslog data-submission surface is
// feature-flagged off in Phase 5. The endpoints stay live (Acoustic phase
// reuses them); only the customer-facing nav item, routes, and dashboard
// widget are gated behind this flag. The issue-attachment picker in
// features/issues/ is NOT gated — attachments are a separate surface.
export function isDataUploadsEnabled(): boolean {
  return readFlag(import.meta.env.VITE_FEATURE_DATA_UPLOADS, false);
}

// Wells telemetry (Phase 6) is built and tested but held back from the initial
// launch, so the customer-facing nav item and route are gated here. Defaults to
// OFF: the flag has to be set explicitly to expose the surface, so a deploy that
// forgets to set it ships without Wells rather than accidentally with it. Dev
// and staging enable it via VITE_FEATURE_WELLS=true.
//
// The backend telemetry endpoints stay live either way — device ingest must keep
// accepting readings, and this flag only governs the customer-facing UI. The
// admin site/well/token screens are NOT gated: staff still need to provision
// wells and issue tokens ahead of the Wells rollout.
export function isWellsEnabled(): boolean {
  return readFlag(import.meta.env.VITE_FEATURE_WELLS, false);
}
